"use client"

import { useTranslations } from "next-intl"

import { Button } from "@/components/ui"
import { CHECKOUT_LINK_ATTRIBUTE } from "@/lib/checkout/pdp-checkout-link"
import { opensElsewhere } from "@/lib/helpers/link-click"
import { useFlowRoutes } from "@/platform/experiments/FlowRoutesProvider"

const CTA_FRAME = "h-13 font-text text-copy-lg font-normal shadow-cta @3xl:h-13"

interface PdpBuyCtaProps {
  soldOut?: boolean
  buying?: boolean
  onBuy: () => void
  disabled?: boolean
  needsOption?: string
  promptId?: string
  href?: string
  // The floating dock's copy: a bare label.
  docked?: boolean
  className?: string
}

export const PdpBuyCta = ({ soldOut = false, buying = false, onBuy, disabled = false, needsOption, promptId, href, docked = false, className }: PdpBuyCtaProps) => {
  const t = useTranslations("pdp")
  const flowRoutes = useFlowRoutes()
  const buyLabel = docked ? (
    t("payWithNelo")
  ) : (
    <span className="flex min-w-0 flex-col items-center">
      <span className="truncate">{t("payWithNelo")}</span>
    </span>
  )
  if (soldOut) {
    return (
      <Button variant="muted" size="lg" fullWidth disabled className={`${CTA_FRAME} ${className ?? ""}`}>
        {t("soldOut")}
      </Button>
    )
  }
  if (href && !buying && !disabled && !needsOption) {
    return (
      <Button asChild variant="primary" size="lg" fullWidth className={`${CTA_FRAME} ${className ?? ""}`}>
        <a
          href={href}
          rel="nofollow"
          {...(flowRoutes ? {} : { [CHECKOUT_LINK_ATTRIBUTE]: "" })}
          onClick={(event) => {
            if (opensElsewhere(event)) return
            event.preventDefault()
            onBuy()
          }}
        >
          {buyLabel}
        </a>
      </Button>
    )
  }
  return (
    <Button
      variant={needsOption ? "muted" : "primary"}
      size="lg"
      fullWidth
      loading={buying}
      disabled={disabled && !needsOption}
      onClick={onBuy}
      aria-describedby={needsOption ? promptId : undefined}
      className={`${CTA_FRAME} ${className ?? ""}`}
    >
      {needsOption ? t("chooseOption", { option: needsOption.toLowerCase() }) : buyLabel}
    </Button>
  )
}
